/* src/app/modules/contact/contact/contact-import.component.css */
.cid--page {
  max-height: none;
  min-width: 0;
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 12px;
}
.cid-header-text {
  min-width: 0;
  padding-right: 36px;
}
.cid-hint {
  margin: -4px 0 12px;
  font-size: 13px;
  color: var(--cf-text-muted, #6b7280);
}
.cid-section {
  margin-top: 20px;
}
.cid-tile {
  width: 100%;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  margin: 0;
}
.cid-tile mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  opacity: 0.65;
}
.cid-tile--wide {
  flex-direction: row;
  gap: 12px;
}
.cid-progress {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 24px 28px;
}
.cid-progress mat-progress-bar {
  flex: 1;
}
.cid-progress__label {
  font-size: 13px;
  font-weight: 600;
  color: var(--cf-text-muted, #6b7280);
  min-width: 40px;
  text-align: right;
}
.cid-file {
  min-width: 0;
}
.cid-file mat-icon {
  flex-shrink: 0;
}
.cid-file__name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cid-file__count {
  margin-left: auto;
  flex-shrink: 0;
  font-weight: 500;
}
.cid-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 8px;
  max-height: 45vh;
}
.cid-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.cid-table th {
  position: sticky;
  top: 0;
  background: var(--cf-bg, #f4f6f8);
  color: var(--cf-text-muted, #6b7280);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: left;
  white-space: nowrap;
  padding: 10px 12px;
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
}
.cid-table td {
  padding: 8px 12px;
  color: #1a1d23;
  white-space: nowrap;
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
}
.cid-table tbody tr:last-child td {
  border-bottom: none;
}
.cid-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 12px 14px;
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 8px;
  background: var(--cf-bg, #f4f6f8);
  color: var(--cf-text-muted, #6b7280);
  font-size: 13px;
}
.cid-empty mat-icon {
  flex-shrink: 0;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.cid-warning-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  padding: 10px 12px;
  border: 1px solid #fcd34d;
  border-radius: 8px;
  background: #fffbeb;
  color: #92400e;
  font-size: 13px;
}
.cid-warning-summary mat-icon {
  flex-shrink: 0;
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--cf-warning, #d97706);
}
.cid-table tbody tr.cid-row--warning td {
  background: #fffbeb;
}
.cid-table td.cid-warnings {
  white-space: normal;
  min-width: 220px;
  color: #92400e;
  font-size: 12px;
}
.cid-warnings__item {
  display: block;
}
/*# sourceMappingURL=contact-import.component.css.map */
